<template>
  <div>

    <Head style="background-color: #cbb486" />
    <div class="background-index">
      <img :src="pic" alt="">
    </div>
    <BreadCrumbs />
    <Content />
    <Footer />
  </div>
</template>

<script>
import BreadCrumbs from '@/components/home/breadCrumbs'
import Content from './siderContent-01'
import Head from "@/components/index/head"
import Footer from "@/components/index/footer"
import { getHomePic, getpicCode } from "@/api/homeIndex.js";
import { getFileDetails } from "@/api/file";
export default {
  name: 'html-content',
  components: {
    BreadCrumbs,
    Content,
    Head,
    Footer
  },
  data () {
    return {
      pic: ""
    }
  },
  created () {
    window.scrollTo(0, 0)
  },
  watch: {
    $route: {
      handler (val, oldVal) {
        let moduleCode = ""
        console.log(val.query.linkname);
        let linkTitle = val.query.linkname.split('/')[0]
        if (linkTitle == "出国签证") {
          moduleCode = "RES36AD957580E1754";
        }
        if (linkTitle == "领事认证") {
          moduleCode = "RES3C89A31F443250F";
        }
        if (linkTitle == "翻译服务") {
          moduleCode = "RESEEFE7D520926995";
        }
        if (linkTitle == "出国服务") {
          moduleCode = "RES6C503B3AEEC09DA";
        }
        if (linkTitle == "外企服务") {
          moduleCode = "RESBE46BCD6A96E5DB";
        }
        if (moduleCode) {
          this.getPic(moduleCode);
        } else {

          this.pic = "/image/group1/M00/00/0B/CgqYdGLzC1CAFI5KADgJlkllpvM307.png?attname=bg_top_xiamen@2x.png"
        }
      },
      deep: true,
      immediate: true,
    }
  },
  methods: {
    async getPic (moduleCode) {
      let picData = await getpicCode(moduleCode);
      let picCode = this._.get(picData, "data.records.0.picCode", "");
      let codeList = [];
      let pic = await getHomePic(picCode, "96F307B9D0EDF9F");
      let appCode = this._.get(pic, "data.appCode", "");
      let tenantCode = this._.get(pic, "data.tenantCode", "");
      codeList.push(
        this._.get(pic, "data.contentPicFileDtoList.0.fileCode", "")
      );
      // console.log('1', appCode, '2', tenantCode, '3', codeList);
      let list = await getFileDetails(appCode, tenantCode, codeList);
      let iList = [];
      iList.push(...Object.values(this._.get(list, "data", {})));

      this.pic = iList[0].fileHttpUrl;
      // this.$refs.backgroundPic.style.backgroundImage = `url(${iList[0].fileHttpUrl})`
      console.log('图片：', this.pic);
    },
  }
}
</script>

<style scoped lang='less'>
.background-index {
  height: 190px;
  width: 100%;
  img {
    width: 100%;
    height: 100%;
  }
  /* position: absolute; */
  /* index: -1; */
  // background-image: url('../../../assets/images/icon_window_service_bg.png');
  // background-size: 100% 100%;
  // background-repeat: no-repeat;
  // background-position:center;
}
</style>



// WEBPACK FOOTER //
// src/components/home/htmlContent/index.vue